import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';

// Own constants/actions/components
import { getSessionAction } from 'services/actions/header';
import Header from 'components/header';
import Menu from 'components/menu';
import MenuMobile from 'components/menu-mobile';
import { items } from 'services/selectors/shopping-cart';

const HeaderContainer = () => {
  const sessionActive = Cookies.get('frontSession') !== undefined;
  const dispatch = useDispatch();
  const [dataSession, setDataSession] = useState({});
  const [loader, setLoader] = useState(true);
  const itemsCart = useSelector(items);

  useEffect(() => window.scrollTo(0, 0), []);

  useEffect(async () => {
    const response = await dispatch(getSessionAction());
    const {
      action: {
        payload: {
          data,
          status,
        },
      },
    } = response;

    setDataSession(data);

    if (status === 400 || status === 403 || status === 409 || status === 412 || status === 500) {
      Cookies.remove('frontSession');
      setLoader(false);
    }
    if (status === 200) {
      setLoader(false);
    }
    if (status === 200 && Cookies.get('frontSession') === undefined) {
      const inTwentyMinutes = new Date(new Date().getTime() + 20 * 60 * 1000);
      Cookies.set('frontSession', 'experiencias', {
        expires: inTwentyMinutes,
      });
    }
  }, []);

  return (
    <div>
      <Header
        session={sessionActive}
        account={dataSession ? dataSession.activeCardNo : ''}
        points={dataSession ? dataSession.points : ''}
        name={dataSession ? `${dataSession.name}` : ''}
        loader={loader} />
      <Menu number={itemsCart.length} />
      <MenuMobile session={sessionActive} />
    </div>
  );
};

export default HeaderContainer;
